/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'

const ProtectedUserManagementIndexLazyRouteImport = createFileRoute(
  '/_protected/user-management/',
)()
const ProtectedFacilityManagementIndexLazyRouteImport = createFileRoute(
  '/_protected/facility-management/',
)()
const ProtectedEncounterHistoryIndexLazyRouteImport = createFileRoute(
  '/_protected/encounter-history/',
)()
const ProtectedApprovalsIndexLazyRouteImport = createFileRoute(
  '/_protected/approvals/',
)()

const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedUserManagementIndexLazyRoute =
  ProtectedUserManagementIndexLazyRouteImport.update({
    id: '/user-management/',
    path: '/user-management/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/user-management/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedFacilityManagementIndexLazyRoute =
  ProtectedFacilityManagementIndexLazyRouteImport.update({
    id: '/facility-management/',
    path: '/facility-management/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/facility-management/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedEncounterHistoryIndexLazyRoute =
  ProtectedEncounterHistoryIndexLazyRouteImport.update({
    id: '/encounter-history/',
    path: '/encounter-history/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/encounter-history/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ProtectedApprovalsIndexLazyRoute =
  ProtectedApprovalsIndexLazyRouteImport.update({
    id: '/approvals/',
    path: '/approvals/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/approvals/index.lazy').then((d) => d.Route),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/approvals/': typeof ProtectedApprovalsIndexLazyRoute
  '/encounter-history/': typeof ProtectedEncounterHistoryIndexLazyRoute
  '/facility-management/': typeof ProtectedFacilityManagementIndexLazyRoute
  '/user-management/': typeof ProtectedUserManagementIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/approvals': typeof ProtectedApprovalsIndexLazyRoute
  '/encounter-history': typeof ProtectedEncounterHistoryIndexLazyRoute
  '/facility-management': typeof ProtectedFacilityManagementIndexLazyRoute
  '/user-management': typeof ProtectedUserManagementIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/_protected/approvals/': typeof ProtectedApprovalsIndexLazyRoute
  '/_protected/encounter-history/': typeof ProtectedEncounterHistoryIndexLazyRoute
  '/_protected/facility-management/': typeof ProtectedFacilityManagementIndexLazyRoute
  '/_protected/user-management/': typeof ProtectedUserManagementIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/approvals/'
    | '/encounter-history/'
    | '/facility-management/'
    | '/user-management/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/approvals'
    | '/encounter-history'
    | '/facility-management'
    | '/user-management'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/_protected/approvals/'
    | '/_protected/encounter-history/'
    | '/_protected/facility-management/'
    | '/_protected/user-management/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/user-management/': {
      id: '/_protected/user-management/'
      path: '/user-management'
      fullPath: '/user-management/'
      preLoaderRoute: typeof ProtectedUserManagementIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/facility-management/': {
      id: '/_protected/facility-management/'
      path: '/facility-management'
      fullPath: '/facility-management/'
      preLoaderRoute: typeof ProtectedFacilityManagementIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/encounter-history/': {
      id: '/_protected/encounter-history/'
      path: '/encounter-history'
      fullPath: '/encounter-history/'
      preLoaderRoute: typeof ProtectedEncounterHistoryIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/approvals/': {
      id: '/_protected/approvals/'
      path: '/approvals'
      fullPath: '/approvals/'
      preLoaderRoute: typeof ProtectedApprovalsIndexLazyRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedApprovalsIndexLazyRoute: typeof ProtectedApprovalsIndexLazyRoute
  ProtectedEncounterHistoryIndexLazyRoute: typeof ProtectedEncounterHistoryIndexLazyRoute
  ProtectedFacilityManagementIndexLazyRoute: typeof ProtectedFacilityManagementIndexLazyRoute
  ProtectedUserManagementIndexLazyRoute: typeof ProtectedUserManagementIndexLazyRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedApprovalsIndexLazyRoute: ProtectedApprovalsIndexLazyRoute,
  ProtectedEncounterHistoryIndexLazyRoute:
    ProtectedEncounterHistoryIndexLazyRoute,
  ProtectedFacilityManagementIndexLazyRoute:
    ProtectedFacilityManagementIndexLazyRoute,
  ProtectedUserManagementIndexLazyRoute: ProtectedUserManagementIndexLazyRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
